import { createFormHook } from "@tanstack/react-form";

import {
  DatetimeField,
  NumberField,
  PasswordField,
  Select,
  Slider,
  SubmitButton,
  Switch,
  TextField,
} from "./components";
import { fieldContext, formContext } from "./form.context";

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: { DatetimeField, NumberField, PasswordField, Select, Slider, Switch, TextField },
  formComponents: { SubmitButton },
  fieldContext,
  formContext,
});
